/* tslint:disable */
/* eslint-disable */
// this is an auto generated file. This will be overwritten

import * as APITypes from "../API";
type GeneratedQuery<InputType, OutputType> = string & {
  __generatedQueryInput: InputType;
  __generatedQueryOutput: OutputType;
};

export const patientsByLIDAndUpdatedAtShallow = /* GraphQL */ `query PatientsByLIDAndUpdatedAtShallow(
    $lID: ID!
    $updatedAt: ModelStringKeyConditionInput
    $sortDirection: ModelSortDirection
    $filter: ModelPatientFilterInput
    $limit: Int
    $nextToken: String
  ) {
    patientsByLIDAndUpdatedAt(
      lID: $lID
      updatedAt: $updatedAt
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        name
        client
        image
        s3Image
        lID
        cases {
          items {
            id
            title
            description
            historySummary
            planSummary
            communicationSummary
            overviewSummary
            templateData
            pID
            groups
            owners
            updatedAt
            createdAt
            _version
            _deleted
            _lastChangedAt
            caseTemplateId
            __typename
          }
          nextToken
          startedAt
          __typename
        }
        groups
        owners
        updatedAt
        createdAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      nextToken
      startedAt
      __typename
    }
  }
  ` as GeneratedQuery<
  APITypes.PatientsByLIDAndUpdatedAtQueryVariables,
  APITypes.PatientsByLIDAndUpdatedAtQuery
>;